<template>
    <div class="position-relative search-container">
        <div class="search">
            <input @focus="focused = true" @blur="focused = false" type="text" @keyup.enter="toSearch()" v-model="search.search_text">
            <button @click="toSearch()"  class="button btn-small d-none d-lg-block">Поиск</button>
            <button @click="toSearch()"  class="button btn-small d-lg-none d-block"><img src="/svg/search-mobile.svg" alt=""></button>
        </div>

<!--        <div class="search-result search_words" v-if="!search.search_text && search_words && focused">-->
<!--            <div class="search-result-body">-->
<!--                <div class="other&#45;&#45;item" v-for="item in search_words">-->
<!--                    <div @click="toSearch(item)" class="cursor-pointer">{{item}}</div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->

        <div class="search-result" v-if="search.search_text && search.search_text.length > 2">

            <div class="search-result-body">
                <div v-if="loading" class="loading-box">
                    <b-spinner></b-spinner>
                </div>

                <div v-if="products">
                    <div v-for="item in products" class="product--item">
                        <div class="image-box">
                            <router-link :to="'/catalog/product/' + item.slug"><img :src="'https://app.skybase.ru/public/actions/39947490820098?fileid=' + item.code + '-f64'" alt=""></router-link>
                        </div>
                        <div class="name font-700"><router-link :to="'/catalog/product/' + item.slug">{{item.name}}</router-link></div>
                        <div v-if="item.discount_flag == null || item.discount_flag == 0">{{item.day_price}} RUB/сутки</div>
                        <div v-else>{{item.discount_new_price}} RUB</div>
                        <div class="d-flex align-items-center">
                            <button class="count-btn" @click="countDecrease(item)">
                                <img src="/svg/count-less.svg" alt="">
                            </button>
                            <span class="pl-1 pr-1">{{item.count}}</span>
                            <button class="count-btn" @click="countIncrease(item)">
                                <img src="/svg/count-more.svg" alt="">
                            </button>

                        </div>

                        <div  class="icon-link cursor-pointer" v-if="!store.checkItemBasket(item.code)" :id="'button_' + item.code" @click="addBasket(item)">
                            <img src="/svg/basket-dark.svg" alt="">
                        </div>
                        <div v-else>
                            <img src="/svg/basket-primary.svg" alt="">
                        </div>
                    </div>
                </div>

                <div v-if="news" class="other--item">
                    <div class="h5 font-700">Новости:</div>
                    <div v-for="item in news">
                        <router-link :to="'/news/' + item.slug.en" class="other--item__element">
                            {{item.title.en}}
                            <span class="color-primary d-none d-sm-block">Подробнее</span>
                        </router-link>
                    </div>
                </div>

                <div v-if="projects" class="other--item">
                    <div class="h5 font-700">Проекты:</div>
                    <div v-for="item in projects">
                        <router-link :to="'/projects/' + item.slug" class="other--item__element">
                            {{item.title}}
                            <span class="color-primary d-none d-sm-block">Подробнее</span>
                        </router-link>
                    </div>
                </div>

                <div v-if="rules" class="other--item">
                    <div class="h5 font-700">Правила:</div>
                    <div v-for="item in rules">
                        <router-link :to="'/projects/' + item.slug" class="other--item__element">
                            {{item.title}}
                            <span class="color-primary d-none d-sm-block">Подробнее</span>
                        </router-link>
                    </div>
                </div>

                <div v-if="services" class="other--item">
                    <div class="h5 font-700">Услуги:</div>
                    <div v-for="item in services">
                        <router-link :to="'/projects/' + item.slug" class="other--item__element">
                            {{item.title}}
                            <span class="color-primary">Подробнее</span>
                        </router-link>
                    </div>
                </div>

                <div v-if="shares" class="other--item">
                    <div class="h5 font-700">Акции:</div>
                    <div v-for="item in shares">
                        <router-link :to="'/projects/' + item.slug" class="other--item__element">
                            {{item.title}}
                            <span class="color-primary d-none d-sm-block">Подробнее</span>
                        </router-link>
                    </div>
                </div>

                <div class="btn-to-search cursor-pointer" v-if="products || shares || projects || rules || services || shares" @click="toSearch()">
                    <div class="link-catalog font-700">Посмотреть все результаты</div>
                </div>

                <div v-if="!products && !shares && !projects && !rules && !services && !shares && !news" class="no-result">
                    <div class="h5 mb-0">К сожалению, по Вашему запросу ничего не найдено.</div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import store  from '../../services/data';
    export default {
        data() {
            return {
                search: {
                    search_text: null,
                    page_products: 0,
                    page_news: 0,
                    page_services: 0,
                    page_shares: 0,
                    page_projects: 0,
                    page_rules: 0,
                },
                loading: false,
                search_words: null,

                focused: false,

                products: [],
                news: null,
                projects: null,
                rules: null,
                services: null,
                shares: null,

                store: store,
                timer: null
            }
        },

        watch: {
            'search.search_text'() {
                if (this.timer) clearTimeout(this.timer);
                this.loading = true;
                if (this.search.search_text && this.search.search_text.length > 2)
                    this.timer = setTimeout(this.searchItems, 300);
            },

            $route() {
                if(this.$route.name !== 'pages-search') this.search.search_text = null;
            }
        },

        mounted() {
            this.search_words = JSON.parse(this.store.getItemlocalStorage('search_words'));
            this.store.getBasketItems();
        },

        methods: {
            countDecrease(curretnItem) {
                if (curretnItem.count > 1) {
                    curretnItem.count--;
                    this.updateLocalStorage(curretnItem);
                }
            },
            countIncrease(curretnItem) {
                curretnItem.count ++;
                this.updateLocalStorage(curretnItem);
            },
            updateLocalStorage(curretnItem) {
                let storage_item = JSON.parse(this.store.getItemlocalStorage('chosen-products'));
                storage_item.forEach(item => {
                    if(item.code == curretnItem.code) item.count = curretnItem.count;
                });
                this.store.state.basket_items.forEach(item => {
                    if(item.code == curretnItem.code) item.count = curretnItem.count;
                });
                this.store.setItemlocalStorage('chosen-products', storage_item);
                this.store.getCommonPrice();
            },
            searchItems() {
                this.loading = true;
                let url = '/api/search';
                axios.post(url, this.search)
                    .then(response => {
                        this.products = [];
                        if (response.data.products_count) {
                            let currentProducts = null;
                            if (response.data.products_count > 5) {
                                currentProducts = response.data.products.slice(0, 5);
                            } else {
                                currentProducts = response.data.products;
                            }
                            currentProducts.forEach(currentProduct => {
                                let count = 1;
                                let item =  store.getItemBasket(currentProduct.code);
                                if (item != null) {
                                    count =  item.count;
                                }
                                let newItem = {
                                    'slug' : currentProduct.slug,
                                    'code' : currentProduct.code,
                                    'name' :currentProduct.name,
                                    'day_price' : currentProduct.day_price,
                                    'discount_flag' : currentProduct.discount_flag,
                                    'discount_new_price' : currentProduct.discount_new_price,
                                    'discount_old_price' : currentProduct.discount_old_price,
                                    'threeHoure_price' :currentProduct.threeHoure_price,
                                    'count' : count,
                                    'accessories': currentProduct.accessories,
                                };
                                this.products.push(newItem);
                            });
                        }

                        if(response.data.news_count) this.news = response.data.news;
                        else this.news = null;

                        if(response.data.projects_count) this.projects = response.data.projects;
                        else this.projects = null;

                        if(response.data.rules_count) this.rules = response.data.rules;
                        else this.rules = null;

                        if(response.data.services_count) this.services = response.data.services;
                        else this.services = null;

                        if(response.data.shares_count) this.shares = response.data.shares;
                        else this.shares = null;

                        this.loading = false
                    });


            },
            addBasket(item) {
                let data = {
                    code: item.code,
                    // slug: item.slug,
                    // name: item.name,
                    // day_price: item.day_price,
                    // threeHoure_price: item.threeHoure_price,
                    count: item.count,
                };
                this.store.addToBasket(data);
                if (item.accessories && this.$route.name !== 'pages-catalog-show') this.store.state.basket_accessories = item.accessories;
                else this.store.state.basket_accessories = null;

                this.itemFromBasket = this.store.checkItemBasket(item.code);

                this.$root.$emit('bv::show::modal', 'addBasketModal', '#button_' + item.code);
                this.toSearch();
                // this.search.search_text = null;
            },

            toSearch() {
                if(this.search.search_text) {
                    // let search_text = this.search.search_text;
                    // if(this.store.getItemlocalStorage('search_words')) {
                    //     let words = JSON.parse(this.store.getItemlocalStorage('search_words'));
                    //     words.unshift(search_text);
                    //
                    //     if(words.length > 10) words.splice(10, 1);
                    //     this.search_words = words;
                    //     this.store.setItemlocalStorage('search_words', words);
                    // }
                    // if(!this.store.getItemlocalStorage('search_words')) {
                    //     let words = [];
                    //     words.push(search_text);
                    //     this.search_words = words;
                    //     this.store.setItemlocalStorage('search_words', words);
                    // }


                    this.$router.push({ path: '/search?search=' + this.search.search_text });
                    this.search.search_text = null;
                }
            },

        }
    }
</script>
